import React, { useContext } from 'react';
import { draftStore, sponsorsStore } from '../../../store';
import * as actions from '../../../actions/options';
import { Row, Col } from '../../../components/layout'
import { SelectInput } from '../../../components/input';
import { useMediaQuery } from 'react-responsive';
import { mobileBreakpoint } from '../../../lib';
import { PresentedBy } from '../../../components';

const yearOptions = ['2025','2024','2023','2022','2021','2020','2019','2018','2017','2016','2015','2014','2013','2012','2011','2010',
                     '2009','2008'];

const rankingOptions = [
    //{value: 'NHL', label: 'NHL'},
    {value: 'FC', label: 'FCHockey'},
    {value: 'Consensus', label: 'Consensus'}
];

function OptionFilters(){

    const { state, dispatch } = useContext(draftStore);
    const { state: { mockDraft } } = useContext(sponsorsStore);
    const { options: {year, rankings} } = state;
    const isMobile = useMediaQuery({maxWidth: mobileBreakpoint});
    const isExtraSmallMobile = useMediaQuery({maxWidth: '425px'});

    return (
        <Row margin={isMobile ? '10px 0 0' : '20px 0 30px'} justifyContent={'space-between'}>
            <Col alignItems="center">
                <SelectInput
                    value={year}
                    onChange={(e)=>dispatch(actions.setDraftYear(e.target.value))}
                    options={yearOptions.map((opt)=>({label:opt,value:opt}))}
                    label="Draft Year"
                    selectId="draft-year"
                    inputPadding={isExtraSmallMobile ? '0 30px 0 0' : '0 43px 0 0'}
                    margin="0 40px 0 0"
                />
                <SelectInput
                    value={rankings}
                    onChange={(e)=>dispatch(actions.setRankings(e.target.value))}
                    options={rankingOptions}
                    label="Rankings"
                    selectId="rankings"
                    inputPadding={isExtraSmallMobile ? '0 30px 0 0' : '0 47px 0 0'}
                />
            </Col>
            {!isMobile && <Col alignItems="center" margin={'20px 0 0 0'}>
                <PresentedBy logo={mockDraft.url} />
            </Col>}
        </Row>
    )
}

export default OptionFilters;